import gql from "graphql-tag";

const GET_APPOINTMENT_TYPES = gql`
  query {
    getAllAppointmentTypes {
      id
      name
    }
  }
`;
export default GET_APPOINTMENT_TYPES;
